import { useMutation } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { FieldValues } from 'react-hook-form';

export interface ICPFValidate {
  cpf?: boolean;
  message: string;
}

const documentValidation = async (data: FieldValues) => {
  const digits = data.document_number.replace(/\D/g, '') ?? '';

  const response = await configApi.post<ICPFValidate>('candidate/validate/', {
    is_foreign: data.is_foreign,
    [data.is_foreign ? 'passport_number' : 'cpf']: data.is_foreign ? data.document_number : digits,
  });
  return response;
};

export const useDocumentValidation = () => {
  return useMutation({
    mutationFn: (data: FieldValues) => documentValidation(data),
    mutationKey: ['validationCPF'],
  });
};
